/**
 * Accessibility/UX fix: native checkboxes and radios only activate on
 * Space, never Enter -- that's standard browser behavior, not a bug, but
 * it's an easy thing for a keyboard user to expect to "just work" on a
 * filter control. This makes Enter behave the same as Space for the
 * checkboxes/radios inside the collection filter sidebar, without
 * changing anything about their native Space/click behavior.
 */
(function () {
  'use strict';

  function onKeydown(e) {
    if (e.key !== 'Enter' && e.code !== 'Enter') return;
    const target = e.target;
    if (!target || !(target.matches('input[type="checkbox"]') || target.matches('input[type="radio"]'))) return;
    e.preventDefault();
    target.click();
  }

  document.addEventListener('keydown', function (e) {
    if (!e.target || !e.target.closest('[data-collection-filters-form]')) return;
    onKeydown(e);
  });
})();
